import React from "react";
import { observer } from "mobx-react";
import { ContentContainer, DateSeparator, SeparationLine, ErrorWrapper, EmptyWrapper, LoaderWrapper } from "./Content.styled";
import TaskItemList from "../TaskItemList/TaskItemList";
import { Typography, WidgetEmptyErrorPlaceholder, CircularProgress } from "@ann/web-components";

const toDate = (ts) => {
  const parts = ts.split("·");
  const datePart = (parts[1] || "").trim(); // "03/13/24"
  const [mm, dd, yy] = datePart.split("/").map(Number);
  const year = 2000 + (yy || 0);
  return new Date(year, (mm || 1) - 1, dd || 1);
};

const monthKey = (date) =>
  date.toLocaleString("en-US", { month: "long", year: "numeric" });


const groupByMonth = (items) => {
  if (!items || items.length === 0) return {};
  return items
    .slice()
    .sort((a, b) => toDate(b.timestamp) - toDate(a.timestamp))
    .reduce((acc, item) => {
      const key = monthKey(toDate(item.timestamp));
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});
};

const Content = observer(({ loading = false, error = null, tasks = [], onRefresh }) => {
  const hasData = tasks && tasks.length > 0;
  const groups = groupByMonth(tasks);

  if (loading) {
    return (
      <ContentContainer>
        <LoaderWrapper>
          <CircularProgress size="medium" />
        </LoaderWrapper>
      </ContentContainer>
    );
  }

  if (error) {
    return (
      <ContentContainer>
        <ErrorWrapper>
          <WidgetEmptyErrorPlaceholder
            icon="error"
            title="Something went wrong"
            message="We couldn't load tasks. Please try again."
            buttonText="Retry"
            showButton={true}
            onClick={onRefresh}
          />
        </ErrorWrapper>
      </ContentContainer>
    );
  }

  if (!hasData) {
    return (
      <ContentContainer>
        <EmptyWrapper>
          <WidgetEmptyErrorPlaceholder
            icon="searchOff"
            title="You don't have any tasks right now."
            message="We'll show them here once available."
            showButton={false}
          />
        </EmptyWrapper>
      </ContentContainer>
    );
  }

  return (
    <ContentContainer>
      {Object.entries(groups).map(([label, items]) => (
        <React.Fragment key={label}>
          <DateSeparator>
            <Typography category="body" weight="regular" size="medium" color="body">
              {label}
            </Typography>
            <SeparationLine />
          </DateSeparator>

          {items.map((item) => (
            <TaskItemList key={item.id} info={item} />
          ))}
        </React.Fragment>
      ))}
    </ContentContainer>
  );
});

export default Content; 